/* eslint-disable no-param-reassign */

import {IElement} from '../../../incase-domain/elements';

function start(event: Interact.DragEvent, elementPosition: {x: number; y: number}): void {
    const targetEl = event.target as HTMLElement;

    targetEl.style.userSelect = 'none';

    const data = {
        ...elementPosition,
    };

    setDatasetAttrs(targetEl, data);
    setStyleAttrs(targetEl, data);
}

function move(event: Interact.DragEvent, scale = 1): void {
    const targetEl = event.target as HTMLElement;
    const data = {
        x: Number(targetEl.dataset.x) + event.dx / scale,
        y: Number(targetEl.dataset.y) + event.dy / scale,
    };
    setDatasetAttrs(targetEl, data);
    setStyleAttrs(targetEl, data);
}

function end(
    event: Interact.DragEvent,
    elementPosition: {x: number; y: number},
    clientWidth: number,
    clientHeight: number,
    updateElement: (element: Partial<IElement>) => void
): void {
    const targetEl = event.target as HTMLElement;
    const {x, y} = elementPosition;

    const data = {
        x: (x / clientWidth) * 100,
        y: (y / clientHeight) * 100,
    };

    targetEl.style.left = `${data.x}%`;
    targetEl.style.top = `${data.y}%`;

    const updatedElement = {
        xPosition: data.x,
        yPosition: data.y,
    };
    updateElement(updatedElement);
}

function setStyleAttrs(
    targetEl: HTMLElement,
    d: {
        x: number;
        y: number;
    }
): void {
    targetEl.style.left = `${d.x}px`;
    targetEl.style.top = `${d.y}px`;
}

function setDatasetAttrs(
    targetEl: HTMLElement,
    d: {
        x: number;
        y: number;
    }
): void {
    targetEl.dataset.x = d.x.toString();
    targetEl.dataset.y = d.y.toString();
}

export const drag = {start, move, end};
